import T from 'utils/T';
import ex from 'utils/ex';
import React from 'react';
import './HBox.css';
export default React.forwardRef(function HBox(props, ref) {
  const {
    full,
    between,
    stretch,
    center,
    start,
    end,
    vstart,
    vcenter,
    vend,
    vstretch,
    ...rest
  } = props || {};
  return (
    <div {...ex(['HBox', { full, between, stretch, center, start, end, vstart, vcenter, vend, vstretch }], rest)} {...{ ref }}>
    </div>
  );
});